import { makeObservable, observable, runInAction, action, makeAutoObservable } from 'mobx';
import { TimesheetServices } from '../services/timesheetServices';
import i18n from 'i18next';
import { toast } from "react-toastify";
import { ExpenseService } from '../services/expenseServices';

export default class TimesheetStore {
 
    rootStore;
    /*activities = [];
    activity = {};*/
    months = [];
    month = {};
    available=[];
    developers = [];

    expensesSummary = {
        isPendingApproval: false,
        expensesWithPackages: [],
        expensesWithActualCosts: [],
        expensesWithPackagesTotal: 0,        
    };

    constructor(rootStore) {
        this.rootStore = rootStore;

        makeObservable(this, {
            /*activities: observable,
            activity: observable,
            getAll: action,
            getById: action,
            remove: action,
            save: action,
            reset: action,
            duplicate: action,
            getUserActivities: action,*/
            expensesSummary: observable,
            saveHours: action,
            setMonthStatus: action,
            getDevsMonths: action,
            getDevsMonthsFilteredByActivity: action,
            getAvailableMonths: action,
            getDevelopers:action,
            setFinished: action,
            getExpensesSummary: action,
            approveInternalExpense: action,
            rejectInternalExpense: action,
            sendToPendingValidation: action
        });
    }

    getDevelopers = async () => {
        try {
            const data = await TimesheetServices.getDevs();
            runInAction(() => {
                this.developers = data;
            })
        }
        catch (error) {
            runInAction(() => {
                this.developers = [];
            });
        }
    };

    getAvailableMonths = async () => {
        try {
            const data = await TimesheetServices.getAvailableMonths();
            runInAction(() => {
                this.available = data;
            })
        }
        catch (error) {
            runInAction(() => {
                this.available = [];
            });
        }
    };

    getDevsMonths = async (dev, month) => {
        try {            
            const data = await TimesheetServices.getDevsMonths(dev, month);
            runInAction(() => {                
                this.months = data;                
            })
        }
        catch (error) {
            runInAction(() => {
                this.months = [];                
            });
        }
    };

    getDevsMonthsFilteredByActivity = async (dev, month, activity) => {
        const filterFields = {
            1: "pendingConsultantCount",
            2: "pendingValidationCount",
            3: "rejectedCount",
            4: "validatedCount",
            5: "adminValidatedCount",
            6: "billedCount",
        };

        try {
            const data = await TimesheetServices.getDevsMonths(dev, month);
            const field = filterFields[Number(activity)];

            runInAction(() => {
                this.months = field ? data.filter(x => x[field] > 0) : data;
            });
        } catch (e) {
            console.error("Error in getDevsMonthsFilteredByActivity:", e);
            runInAction(() => {
                this.months = [];
            });
        }
    };

    getDevsMonth = async (filter) => {
        try {
            
            const data = await TimesheetServices.getDevsMonth(filter);
            runInAction(() => {                
                this.month = data;
            })
        }
        catch (error) {
            runInAction(() => {                
                this.month = {};
            });
        }
    };

    updateDate = async (key,type,value) => {

        try {
            var d = { key: key, type: type/*, isEnabled: enabled */};
            if (type == 6) { d.information = value } else {
                d.isEnabled = value;
            }
            const data = await TimesheetServices.updateDate(d);
            toast.success(`${i18n.t("monthStatusUpdated")}`);
            return data;
        } catch (error) {
            /*runInAction(() => {
                toast.error(i18n.t(error || "errorOcurred"));
            });*/
        }

    };

    setFinished = async (key, enabled, onError) => {

        try {
            const data = await TimesheetServices.setFinished({ key: key, isEnabled: enabled });
            runInAction(() => {
                toast.success(`${i18n.t("monthStatusUpdated")}`);
            });
            return data;
            
        } catch (error) {
            onError?.(error);            
        }

    };

    saveHours = async (entity, onSuccess) => {

        try {            
            const data = await TimesheetServices.saveHours(entity);
            runInAction(() => {
                if (onSuccess) { onSuccess() };
                //this.reset();
                toast.success(`${i18n.t("hoursUpdated")}`);
            });
        } catch (error) {
            /*runInAction(() => {
                toast.error(i18n.t(error || "errorOcurred"));
            });*/
        }

    };

    setMonthStatus = async (entity, onSuccess) => {
        
        try {
            switch (entity.status) {
                case 1:
                    await TimesheetServices.setMonthPending(entity);
                    runInAction(() => { if (onSuccess) { onSuccess() }; toast.success(`${i18n.t("monthsSentPending")}`); });
                    break;
                case 2:
                    await TimesheetServices.setMonthRejected(entity);
                    runInAction(() => { if (onSuccess) { onSuccess() }; toast.success(`${i18n.t("monthsRejected")}`); });
                    break;
                case 3:
                    await TimesheetServices.setMonthValidated(entity);
                    runInAction(() => { if (onSuccess) { onSuccess() }; toast.success(`${i18n.t("monthsValidated")}`); });
                    break;
                case 5:
                    await TimesheetServices.setMonthFinalized(entity);
                    runInAction(() => { if (onSuccess) { onSuccess() }; toast.success(`${i18n.t("monthsFinalized")}`); });
                    break;
                default:
                    break;
            }
        } catch (error) {
            /*runInAction(() => {
                toast.error(i18n.t(error || "errorOcurred"));
            });*/
        }

    };

    getBilledReport = async (year,month,activityId) => {
        try {
            const data = await ExpenseService.getBilledReport(year, month, activityId);
            return data;
        } catch {
            return null;
        }
    }

    getCostsReport = async (id, summary) => {
        try {
            const data = await ExpenseService.getCostsReport(id, summary);
            return data;
        } catch {
            return null;
        }
    }

    getPackageDetailReport = async (id, summary) => {
        try {
            const data = await ExpenseService.getPackageDetailReport(id,summary);
            return data;
        } catch {
            return null;
        }
    }
    getExpensesSummary = async (key) => {
        try {
            let devId = key.split("_")[0];
            let month = key.split("_")[1] - 1;
            let year = key.split("_")[2];
            const data = await ExpenseService.getInternalSummary({ devId: devId, year: year, month: month });
            runInAction(() => {
                this.expensesSummary = data;
            })
        } catch (error) {
            runInAction(() => {
                this.expensesSummary = {
                    expensesWithPackages: [],
                    expensesWithActualCosts: [],
                    expensesWithPackagesTotal: 0
                };
            });
        } finally {
        }
    }

    approveInternalExpense = async (key) => {
        try {
            let devId = key.split("_")[0];
            let month = key.split("_")[1];
            let year = key.split("_")[2];

            const data = await ExpenseService.approveInternalExpense({ devId: devId, year: year, month: month });

            runInAction(() => {
                toast.success(`${i18n.t("approveInternalExpenseSuccessfully")}`);
                this.expensesSummary.internalExpensesStatus = 2;
            });

        } catch (error) {
            runInAction(() => {
                
            });
        } finally {
        }
    }

    rejectInternalExpense = async (key, rejectReason) => {
        try {
            let devId = key.split("_")[0];
            let month = key.split("_")[1];
            let year = key.split("_")[2];

            const data = await ExpenseService.rejectInternalExpense({ devId: devId, year: year, month: month, rejectReason: rejectReason });

            runInAction(() => {
                toast.success(`${i18n.t("rejectInternalExpenseSuccessfully")}`);
                this.expensesSummary.internalExpensesStatus = 3;
            });

        } catch (error) {
            runInAction(() => {

            });
        } finally {
        }
    }

    sendToPendingValidation = async (key) => {
        try {
            let devId = key.split("_")[0];
            let month = key.split("_")[1];
            let year = key.split("_")[2];

            const data = await ExpenseService.sendToValidate({ devId: devId, year: year, month: month - 1 });

            runInAction(() => {
                toast.success(`${i18n.t("sendToPendingValidationInternalExpenseSuccessfully")}`);
                this.expensesSummary.internalExpensesStatus = 1;
            });

        } catch (error) {
            runInAction(() => {

            });
        } finally {
        }
    }
}